/*
 * HomeReducer
 *
 * The reducer takes care of our data. Using actions, we can
 * update our application state. To add a new action,
 * add it to the switch statement in the reducer function
 *
 */

import {
  LOADER_STATUS,
  SET_TOTAL_RECORD,
  PROFILE_INFO,
  SET_GSTR9C_DATA,
  SET_CLEAR_DATA,
  SET_AUTO_POPULATED_HISTORY,
  SET_GSTR9C_HISTORY
} from "./constants";
// The initial state of the App
export const initialState = {
  loaderStatus: false,
  totalRecord: "",
  profileData: [],
  prepareGSTR9CSummary: {},
  autoPopulatedHistory: [],
  gstr9CHistoryData:[],
};

/* eslint-disable default-case, no-param-reassign */
const prepareReducergstr9c = (state = initialState, action) => {
  switch (action.type) {
    case SET_GSTR9C_HISTORY:
      return {
        ...state,
        gstr9CHistoryData:action.payload
      }
    case LOADER_STATUS:
      return {
        ...state,
        loaderStatus: action.loaderStatus,
      };
    case SET_TOTAL_RECORD:
      return {
        ...state,
        totalRecord: action.totalRecord,
      };
    case PROFILE_INFO:
      return {
        ...state,
        profileData: action.profileData,
      };
    case SET_AUTO_POPULATED_HISTORY:
      return {
        ...state,
        autoPopulatedHistory: action.payload,
      };

    case SET_GSTR9C_DATA:
      return {
        ...state,
        prepareGSTR9CSummary: action.payload,
      };
    case SET_CLEAR_DATA:
      return {
        ...state,
        prepareGSTR9CSummary: {},
      };
    default:
      return state;
  }
};


export default prepareReducergstr9c;
